import { render, staticRenderFns } from "./StaffGroupSchedulePurgeButton.vue?vue&type=template&id=6b175b64&scoped=true&"
import script from "./StaffGroupSchedulePurgeButton.vue?vue&type=script&lang=js&"
export * from "./StaffGroupSchedulePurgeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b175b64",
  null
  
)

export default component.exports